import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { MemoryRouter } from "react-router-dom";
import {
  HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY,
  SUPPORT_WIDGET_DEFAULT_TRANSITIONS,
} from "../constants";
import { useSupportWidgetContextV2 } from "../context/supportWidgetContext";
import { computeInsetWithScrollbar } from "../utils/insetUtils";
import FloatingActionButton from "./FloatingActionButton";
import Routes from "./Routes";

const SupportWidgetBody = () => {
  const { isOpen, toggleWidget } = useSupportWidgetContextV2();
  const [launcherInset, setLauncherInset] = useState(0);

  const onFabClick = () => {
    // There are some checks like isOnboardingCompleted etc. which are removed in this basic implementation.
    // completeOnboarding();
    toggleWidget({ shouldTriggerOnWidgetClose: true });
  };

  const onCloseClick = () => {
    toggleWidget({ shouldTriggerOnWidgetClose: true });
  };

  const initialEntries = ["/"];
  const storedLocation = localStorage.getItem(
    HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY,
  );

  if (
    storedLocation &&
    typeof storedLocation === "string" &&
    storedLocation !== "/"
  ) {
    initialEntries.push(storedLocation);
  }

  useEffect(() => {
    setLauncherInset(computeInsetWithScrollbar());
  }, []);

  return (
    <div
      className="fixed bottom-2 right-2 z-[60] flex"
      style={{ right: launcherInset }}
    >
      <Transition show={isOpen} {...SUPPORT_WIDGET_DEFAULT_TRANSITIONS}>
        <div className="relative">
          <MemoryRouter
            initialEntries={initialEntries}
            initialIndex={initialEntries.length - 1}
          >
            <Routes onClose={onCloseClick} />
          </MemoryRouter>
        </div>
      </Transition>

      {!isOpen && (
        <div className="mt-5 flex justify-end">
          <FloatingActionButton isOpen={isOpen} onClick={onFabClick} />
        </div>
      )}
    </div>
  );
};

export default SupportWidgetBody;
